import {
  useEffect,
  useState,
  useRef,
  Suspense,
  useContext,
  useCallback,
  useMemo,
} from "react";
import { GetMasterTypeData } from "../../../Services/Global-Services/GlobalServices";
import { getEmployeeList } from "../EmployeeList/Service/employeeService.js";
import { MultiSelect } from "primereact/multiselect";
import { LazyImage } from "../../../Services/Decorator_Lazy_Loading/ImageVideoLazyLoding.js";
import {
  addProjectTask,
  deleteTask,
  getProjectList,
  getProjectModule,
  getProjectSegment,
  getProjectSubModule,
  getProjectTaskList,
} from "./Service/TaskService.js";
import {
  Link,
  useHistory,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min.js";
import ComponentLoader from "../../../Shared/Sidebar/ComponentLoader.jsx";
import { Paginator } from "primereact/paginator";
import { TostMsg } from "../../../App.js";
import { useLocation } from "react-router-dom";
import { Dropdown } from "primereact/dropdown";
import AddTask from "./Add-Task.jsx";
import { getRawPermissionsArray } from "../../../Routes/AuthGard/usePermissions.js";
import { ProjectModalContext } from "./Service/ProjectModalContext.jsx";

const TaskManagementList = () => {
  const COLUMNS = ["Open", "In Progress", "Review", "Done", "Closed"];
  const COLUMN_COLORS = {
    Open: "var(--s-open)",
    "In Progress": "var(--s-inprog)",
    Review: "var(--s-review)",
    Resolved: "var(--s-resolved)",
    Done: "var(--s-resolved)",
    Closed: "var(--s-closed)",
  };
  const STATUS_UI = [
    { key: "Open", className: "sc-open", icon: "fa-folder-open" },
    { key: "In Progress", className: "sc-inprog", icon: "fa-spinner" },
    { key: "Review", className: "sc-review", icon: "fa-eye" },
    { key: "Resolved", className: "sc-done", icon: "fa-check-circle" },
    { key: "Closed", className: "sc-closed", icon: "fa-lock" },
  ];

  const SORT_OPTIONS = [
    { label: "Modified On(Default)", value: "" },
    { label: "Task Title", value: "TaskName" },
    { label: "Task Number", value: "TASKNUMBER" },
    { label: "Assigned To", value: "AssignedToName" },
    { label: "Priority", value: "PriorityId" },
    { label: "Severity", value: "SeverityId" },
    { label: "Type", value: "TaskTypeId" },
    { label: "Module", value: "ModuleName" },
    { label: "Sub Module", value: "SubModuleName" },
    { label: "Status", value: "StatusId" },
    { label: "Created On", value: "CreatedOn" },
    { label: "Reporter", value: "ReporterFullName" },
  ];

  const [view, setView] = useState("list");
  const [selectedTasks, setSelectedTasks] = useState([]);
  const [showBulkBar, setShowBulkBar] = useState(false);
  const [selectedAssingToName, setSelectedAssingToName] = useState([]);
  const [taskList, setTaskList] = useState([]);
  const [filteredTasks, setFilteredTasks] = useState([]);
  const [inputText, setInputText] = useState("");
  const [searchText, setSearchText] = useState("");
  const [startDate, setStartDate] = useState("2020-01-01");
  const [endDate, setEndDate] = useState("2029-12-31");
  const getValue = (val) => (val ? val : "N/A");
  const [taskSegmentType, setTaskSegmentType] = useState([]);
  const [taskModuleType, setTaskModuleType] = useState([]);
  const [taskSeverityType, setTaskSeverityType] = useState([]);
  const [taskPriorityType, setTaskPriorityType] = useState([]);
  const [taskSubModuleType, setTaskSubModuleType] = useState([]);
  const [taskStatusType, setTaskStatusType] = useState([]);
  const [selectedProject, setSelectedProject] = useState(null);
  const [employeDetails, setEmployeDetails] = useState([]);
  const [loadingCount, setLoadingCount] = useState(0);
  const startLoading = useCallback(() => setLoadingCount(prev => prev + 1), []);
  const stopLoading = useCallback(() => setLoadingCount(prev => Math.max(0, prev - 1)), []);
  const isAnythingLoading = loadingCount > 0;
  const [selectedTask, setSelectedTask] = useState(null);
  const [taskCount, setTaskCount] = useState([]);
  const toster = useContext(TostMsg);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(50);
  const [totalRecords, setTotalRecords] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);
  const [subTaskProjectId, setProjectId] = useState(0);
  const [filterOpen, setFilterOpen] = useState(false);
  const [summaryOpen, setSummaryOpen] = useState(false);
  const [guidApplied, setGuidApplied] = useState(false);
  const [sortBy, setSortBy] = useState("");
  const [sortOrder, setSortOrder] = useState("");
  const debounceTimerRef = useRef(null);
  const [copiedId, setCopiedId] = useState(null);
  let userPermissions = getRawPermissionsArray();
  const statusMap = taskCount.reduce((acc, item) => {
    acc[item.Status] = item.TaskCount;
    return acc;
  }, {});
  const userDetails = useMemo(() => {
    return JSON.parse(localStorage.getItem("User") || "{}");
  }, []);
  const history = useHistory();
  const [selectedraisedBy, setSelectedraisedBy] = useState([]);
  const location = useLocation();
  const [header, setHeader] = useState("");
  const [allProject, setAllProject] = useState([]);
  const [taskType, setTaskType] = useState([]);
  const [deletedTaskId, setDeletedTaskId] = useState(0);
  const [isDeletedModal, setDeleteModal] = useState(false);
  let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");
  const { ProjectGUID } = useParams();
  const normalizedProjectGUID = ProjectGUID?.toString().toLowerCase();
  const [selectedPriority, setSelectedPriority] = useState([]);
  const [selectedSeverity, setSelectedSeverity] = useState([]);
  // const [selectedStatus, setSelectedStatus] = useState();
  const [selectedStatus, setSelectedStatus] = useState([]);
  const [selectedSegment, setSelectedSegment] = useState([]);
  const [selectedSubModule, setSelectedSubModule] = useState([]);
  const [selectedModule, setSelectedModule] = useState([]);
  const [selectedType, setSelectedType] = useState([]);
  const [isModalOpen, setAddModalOpen] = useState(false);
  const [editTaskDetails, setEditTaskDetails] = useState({});
  const [parentId, setParentId] = useState(0);
  const [taskCopy, setTaskCopy] = useState(false);
  const [selectedTaskDrag, setSelectedTaskDrag] = useState([]);
  const { registerProjectSaveCallback } = useContext(ProjectModalContext);
  const [panelEmployees, setPanelEmployees] = useState([]);
  const [localSelectedStatus, setLocalSelectedStatus] = useState();
  const isInitializedRef = useRef(false);
  const selectedProjectRef = useRef(selectedProject);
  const selectedStatusRef = useRef([]);
  const rowsRef = useRef(rows);
  const [panelVisible, setPanelVisible] = useState(false);

  useEffect(() => {
    const statuses = userDetails?.OrgTaskStatus;
    if (statuses?.length) {
      const filteredIds = statuses
        .filter((item) => item.CategoryId === 1)
        .map((item) => item.Id);

      // selectedStatus set karo taaki getProjectTask API mein StatusId filter lage
      selectedStatusRef.current = filteredIds;
      setSelectedStatus(filteredIds);
      setLocalSelectedStatus(filteredIds); // agar localSelectedStatus kahi aur use ho raha ho
    }
    return () => {
      if (debounceTimerRef.current) clearTimeout(debounceTimerRef.current);
    };
  }, []);

  useEffect(() => {
    selectedProjectRef.current = selectedProject;
  }, [selectedProject]);

  useEffect(() => {
    rowsRef.current = rows;
  }, [rows]);

  const hasActiveFilters =
    searchText ||
    selectedStatus?.length > 0 ||
    selectedPriority?.length > 0 ||
    selectedSeverity?.length > 0 ||
    selectedModule?.length > 0 ||
    selectedSubModule?.length > 0 ||
    selectedSegment?.length > 0 ||
    selectedProject !== null ||
    selectedAssingToName?.length > 0 ||
    selectedraisedBy?.length > 0 ||
    selectedType?.length > 0 ||
    startDate ||
    endDate ||
    sortBy;

  const toggleSortOrder = () =>
    setSortOrder((prev) => (prev === "ASC" ? "DESC" : "ASC"));

  useEffect(() => {
    registerProjectSaveCallback(() =>
      getProjectTask(1, rowsRef.current, selectedProjectRef.current)
    );
  }, [registerProjectSaveCallback]);

  // ─── FIX: Init effect - sirf location/ProjectGUID change par chale ──────────
  useEffect(() => {
    isInitializedRef.current = false;

    const init = async () => {
      startLoading(); // ✅ Poori init shuru — loader ON
      try {
        if (location.pathname === "/Project/Task/List") {
          setHeader("My Tasks");
        } else {
          setHeader("All Tasks");
        }

        const [projects] = await Promise.all([
          allProjects(),
          fetchEmployeeIdData(),
          getMasterTaskSeverityCategory(),
          getMasterTaskPriorityCategory(),
          getMasterTaskStatusCategory(),
          getMasterTaskTypeCategory(),
          GetMasterSystemAlertList(),
        ]);

        if (ProjectGUID && projects.length > 0) {
          const normalizedGUID = ProjectGUID.toString().toLowerCase();
          const matchedProject = projects.find(
            (p) => (p?.GUID || "").toString().toLowerCase() === normalizedGUID
          );

          if (matchedProject) {
            const projectId = matchedProject?.Id || matchedProject?.ProjectId || 0;
            setSelectedProject(projectId);
            selectedProjectRef.current = projectId;
            setGuidApplied(true);
            getMasterTaskModulesCategory(projectId);
            getMasterTaskSegementCategory(projectId);
            await fetchEmployeeIdData(projectId);
            isInitializedRef.current = true;
            await getProjectTask(1, rowsRef.current, projectId);
            return;
          }
        }

        isInitializedRef.current = true;
        await getProjectTask(1, rowsRef.current, null, selectedStatusRef.current);

      } finally {
        stopLoading();
      }
    };

    init();
  }, [location.pathname, ProjectGUID]);

  useEffect(() => {
    if (!isInitializedRef.current) return; // init complete hone se pehle mat chalo
    getProjectTask(pageNumber, rowsRef.current);
  }, [
    searchText,
    selectedStatus,
    selectedPriority,
    selectedSeverity,
    selectedModule,
    selectedSubModule,
    selectedSegment,
    selectedProject,
    selectedAssingToName,
    startDate,
    endDate,
    selectedType,
    sortBy,
    sortOrder,
  ]);

  // ─── GUID match after allProject loads ─────────────────────────────────────
  useEffect(() => {
    if (
      ProjectGUID &&
      allProject?.length > 0 &&
      selectedProject === null &&
      !guidApplied
    ) {
      const matchedProject = allProject.find(
        (project) =>
          (project?.GUID || "").toString().toLowerCase() ===
          normalizedProjectGUID
      );

      if (matchedProject) {
        const projectId =
          matchedProject?.Id || matchedProject?.ProjectId || 0;
        setSelectedProject(projectId);
        selectedProjectRef.current = projectId;
        setGuidApplied(true);
        getMasterTaskModulesCategory(projectId);
        getMasterTaskSegementCategory(projectId);
        getProjectTask(1, rowsRef.current, projectId);
      }
    }
  }, [allProject]);

  // ─── HELPERS ─────────────────────────────────────────────────────────────────
  const GetMasterSystemAlertList = useCallback(async (message, type) => {
    SystemAlerts?.filter((msg) => {
      if (msg?.Name == message && type == 0) {
        toster.current.success(msg?.Desc);
      }
    });
  }, []);

  async function allProjects() {
    let body = {
      Id: 0,
      StartDate: "",
      EndDate: "",
      ProjectStatusId: "",
      PageNumber: 1,
      PageSize: 1000,
      Search: "",
      ProjectTypeId: "",
      ClientId: "",
      SortBy: "",
      SortOrder: "",
    };

    try {
      let res = await getProjectList(body);
      const projectList = res?.Data?.ProjectList || [];
      const normalizedProjects = projectList.map((project) => ({
        ...project,
        Id: project?.Id ?? project?.ProjectId ?? 0,
        ProjectId: project?.ProjectId ?? project?.Id ?? 0,
        GUID: (
          project?.GUID ??
          project?.Guid ??
          project?.ProjectGUID ??
          project?.ProjectGuid ??
          ""
        )
          .toString()
          .toLowerCase(),
      }));

      setAllProject(normalizedProjects);
      return normalizedProjects;
    } catch (error) {
      toster.current.error(error.res.Data?.Message || "somthing went wrong"); return [];
    }
  }

  const sBadge = (status) => {
    const map = {
      Active: "bg-active",
      Archived: "bg-archived",
      Open: "bg-open",
      "In Progress": "bg-inprog",
      Review: "bg-review",
      Done: "bg-success",
      Closed: "bg-success",
    };
    return map[status] || "bg-medium";
  };

  async function getProjectTask(
    page = 1,
    pageSize = 10,
    projectId = undefined,
    statusIds = undefined
  ) {
    const assignedId =
      location.pathname === "/Project/Task/List"
        ? userDetails?.EmpId?.toString()
        : "";
    const resolvedProjectId =
      projectId !== undefined ? projectId : selectedProjectRef.current;

    const statusIdValue = typeof statusIds === "string"
      ? statusIds
      : Array.isArray(statusIds)
        ? statusIds.join(",")
        : selectedStatus?.join(",") || selectedStatusRef.current?.join(",") || "";

    const params = {
      RaisedByEmpId: selectedraisedBy?.join(",") || "",
      AssignedToId:
        selectedAssingToName?.length > 0
          ? selectedAssingToName.join(",")
          : assignedId || "",
      TaskId: 0,
      StatusId: statusIdValue,
      ModuleId: selectedModule?.join(",") || "",
      SubModuleId: selectedSubModule?.join(",") || "",
      PriorityId: selectedPriority?.join(",") || "",
      SeverityId: selectedSeverity?.join(",") || "",
      Search: searchText || "",
      FilterStartDate: startDate || "",
      FilterEndDate: endDate || "",
      PageNumber: page,
      PageSize: pageSize,
      IsDeleted: 0,
      SprintId: 0,
      TaskNumber: "",
      TaskGUID: "",
      ProjectId: resolvedProjectId ? resolvedProjectId.toString() : "",
      ParentTaskId: 0,
      TaskTypeId: selectedType?.join(",") || "",
      SegmentId: selectedSegment?.join(",") || "",
      SortBy: sortBy || "",
      SortOrder: sortOrder || "",
    };

    try {
      const data = await getProjectTaskList(params);
      const list = data?.Data?.OrgEmpTasks || [];
      const count = data?.Data?.TaskStatusCounts || [];
      const total = list?.[0]?.TotalCount || 0;
      setTotalRecords(total);
      setTaskCount(count);
      setTaskList(list.map((el) => ({ ...el, isDraggingDropping: false })));
      setFilteredTasks(
        list.map((el) => ({ ...el, isDraggingDropping: false }))
      );
    } catch (error) {
      toster.current.error(error.data.Data?.Message || "somthing went wrong");
    } finally {
      stopLoading();
    }
  }

  async function taskDelete() {
    let body = { Id: deletedTaskId };
    startLoading();
    try {
      if (deletedTaskId) {
        let response = await deleteTask(body);
        if (response?.StatusCode === 2000) {
          GetMasterSystemAlertList("Task_Delete", 0);
          await getProjectTask(1, rowsRef.current);
          setDeleteModal(false);
          setDeletedTaskId(0);
        }
      }
    } catch (error) {
      toster.current.error(error.response.Data?.Message || "somthing went wrong");
    } finally {
      stopLoading();
    }
  }

  const onPageChange = (e) => {
    setFirst(e.first);
    setRows(e.rows);
    rowsRef.current = e.rows;
    const newPage = Math.floor(e.first / e.rows) + 1;
    setPageNumber(newPage);
    getProjectTask(newPage, e.rows);
  };

  const employeeOptionTemplate = (option) => {
    if (!option) return null;
    return (
      <div className="flex align-items-center gap-2 ticket-file-attach__items_detail">
        <LazyImage
          alt={option?.FullName || "User"}
          src={option?.ProfileImage || "/images/placeholder_profile.png"}
          width="32"
        />
        <span>{option?.FullName || "Unknown"}</span>
      </div>
    );
  };

  const sortedEmployeeDetails = useMemo(() => {
    if (!selectedAssingToName?.length) return employeDetails;

    const selected = employeDetails.filter((emp) =>
      selectedAssingToName.includes(emp.Id)
    );
    const unselected = employeDetails.filter(
      (emp) => !selectedAssingToName.includes(emp.Id)
    );

    return [...selected, ...unselected];
  }, [selectedAssingToName, panelVisible, employeDetails]);

  const applyFilters = () => {
    let data = [...taskList];
    const search = searchText.toLowerCase();

    if (search) {
      data = data.filter(
        (t) =>
          (t.TaskTitle || "").toLowerCase().includes(search) ||
          String(t.TaskNumber || "").toLowerCase().includes(search)
      );
    }
    if (selectedStatus?.length) {
      data = data.filter((t) =>
        selectedStatus.map(String).includes(String(t.StatusId))
      );
    }
    if (selectedPriority?.length) {
      data = data.filter((t) =>
        selectedPriority.map(String).includes(String(t.PriorityId))
      );
    }
    if (selectedSeverity?.length) {
      data = data.filter((t) =>
        selectedSeverity.map(String).includes(String(t.SeverityId))
      );
    }
    if (selectedProject) {
      data = data.filter(
        (t) => String(t.ProjectId) === String(selectedProject)
      );
    }
    if (selectedType?.length) {
      data = data.filter((t) =>
        selectedType.map(String).includes(String(t.TaskTypeId))
      );
    }
    if (selectedModule?.length) {
      data = data.filter((t) =>
        selectedModule.map(String).includes(String(t.ModuleId))
      );
    }
    if (selectedSubModule?.length) {
      data = data.filter((t) =>
        selectedSubModule.map(String).includes(String(t.SubModuleId))
      );
    }
    if (selectedSegment?.length) {
      data = data.filter((t) =>
        selectedSegment.map(String).includes(String(t.SegmentId))
      );
    }
    if (selectedAssingToName?.length) {
      data = data.filter((t) =>
        selectedAssingToName.includes(t.AssignedToId)
      );
    }
    setFilteredTasks(data);
  };

  const clearFilters = () => {
    setInputText("");
    setSearchText("");
    setSelectedStatus([0]);
    selectedStatusRef.current = [0];
    setSelectedPriority([]);
    setSelectedSeverity([]);
    setSelectedModule([]);
    setSelectedSubModule([]);
    setSelectedSegment([]);
    setSelectedProject(null);
    selectedProjectRef.current = null;
    setSelectedAssingToName([]);
    setSelectedraisedBy([]);
    setTaskModuleType([]);
    setTaskSubModuleType([]);
    setTaskSegmentType([]);
    setSelectedType([]);
    setStartDate("");
    setEndDate("");
    setSortBy("");
    setSortOrder("ASC");
  };

  const toggleAllSel = (e) => {
    if (e.target.checked) {
      setSelectedTasks(filteredTasks.map((t) => t.Id));
      setShowBulkBar(true);
    } else {
      setSelectedTasks([]);
      setShowBulkBar(false);
    }
  };

  const closePanel = () => setSelectedTask(null);

  async function getMasterTaskSegementCategory(projectId = 0) {
    try {
      const data = await getProjectSegment({ ProjectId: Number(projectId) });
      setTaskSegmentType(data?.Data);
    } catch (error) {
      toster.current.error(error.data.Data?.Message || "somthing went wrong");
    }
  }

  async function fetchPanelEmployees(projectId = 0) {
    const params = {
      OrganisationId: userDetails?.OrgId,
      LoggedInEmployeeId: userDetails?.EmpId,
      IsDirectReportOrHierarchy: 0,
      SearchText: "",
      FollowersOnly: 0,
      FollowingsOnly: 0,
      IsExEmployeesAlso: 0,
      pageNumber: 1,
      pageSize: 10000,
      EmployeeId: 0,
      IsSuggestedOnly: 0,
      ZoneId: 0,
      RegionId: 0,
      ProjectId: Number(projectId) || 0,
    };
    try {
      let res = await getEmployeeList(params);
      setPanelEmployees(res.Data || []);
    } catch (error) {
      toster.current.error(error.res.Data?.Message || "somthing went wrong");
    }
  }

  async function fetchEmployeeIdData(projectId = 0) {
    startLoading();
    const params = {
      OrganisationId: userDetails?.OrgId,
      LoggedInEmployeeId: userDetails?.EmpId,
      IsDirectReportOrHierarchy: 0,
      SearchText: "",
      FollowersOnly: 0,
      FollowingsOnly: 0,
      IsExEmployeesAlso: 0,
      pageNumber: 1,
      pageSize: 10000,
      EmployeeId: 0,
      IsSuggestedOnly: 0,
      ZoneId: 0,
      RegionId: 0,
      ProjectId: Number(projectId) || 0,
    };

    try {
      let employeesList = await getEmployeeList(params);
      setEmployeDetails(employeesList.Data || []);
    } catch (error) {
      toster.current.error(error.employeesList.Data?.Message || "somthing went wrong");
    } finally {
      stopLoading();
    }
  }

  async function getMasterTaskModulesCategory(projectId = 0) {
    try {
      const data = await getProjectModule({ ProjectId: Number(projectId) });
      setTaskModuleType(data?.Data || []);
    } catch (error) {
      toster.current.error(error.data.Data?.Message || "somthing went wrong");
    }
  }

  const toggleSection = (key) => {
    if (key === "filter") {
      setFilterOpen(!filterOpen);
    } else if (key === "summary") {
      setSummaryOpen(!summaryOpen);
    }
  };

  const renderToggleArrow = (isOpen, color = "currentColor") => (
    <svg
      viewBox="0 0 20 20"
      width="18"
      height="18"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      style={{ display: "block" }}
    >
      <path
        d={isOpen ? "M5 12l5-5 5 5" : "M5 7l5 5 5-5"}
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  async function getMasterTaskSeverityCategory() {
    try {
      const data = await GetMasterTypeData({
        organisationId: userDetails?.OrgId,
        masterType: "TaskSeverity",
      });
      setTaskSeverityType(data?.Data);
    } catch (error) {
      toster.current.error(error.data.Data?.Message || "somthing went wrong");
    }
  }

  async function getMasterTaskPriorityCategory() {
    try {
      const data = await GetMasterTypeData({
        organisationId: userDetails?.OrgId,
        masterType: "TaskPriority",
      });
      setTaskPriorityType(data?.Data);
    } catch (error) {
      toster.current.error(error.data.Data?.Message || "somthing went wrong");
    }
  }

  async function getMasterTaskSubModuleCategory(projectId = 0, moduleId = 0) {
    try {
      const data = await getProjectSubModule({
        ProjectId: Number(projectId),
        ModuleId: Number(moduleId),
      });
      setTaskSubModuleType(data?.Data || []);
    } catch (error) {
      toster.current.error(error.data.Data?.Message || "somthing went wrong");
    }
  }

  async function getMasterTaskStatusCategory() {
    try {
      const data = await GetMasterTypeData({
        organisationId: userDetails?.OrgId,
        masterType: "TaskStatus",
      });
      setTaskStatusType(data?.Data);
    } catch (error) {
      toster.current.error(error.data.Data?.Message || "somthing went wrong");
    }
  }

  async function getMasterTaskTypeCategory() {
    try {
      const data = await GetMasterTypeData({
        organisationId: userDetails?.OrgId,
        masterType: "TaskType",
      });
      setTaskType(data?.Data);
    } catch (error) {
      toster.current.error(error.data.Data?.Message || "somthing went wrong");
    }
  }

  const openPanel = (id) => {
    const task = filteredTasks.find((t) => t.Id === id);
    setSelectedTask(task);
  };

  const taskDetail = (id) => {
    window.open(`/Project/Task/Detail/${id}`, "_blank");
  };

  const STATUS_DISPLAY_TO_API = {
    Open: "Open",
    "In Progress": "In Progress",
    Review: "Review",
    Resolved: "Done",
    Closed: "Closed",
  };

  const handleStatusChange = async (taskId, statusName) => {
    startLoading();
    const apiStatusName = STATUS_DISPLAY_TO_API[statusName] || statusName;
    const statusObj = taskStatusType.find((s) => s.Name === apiStatusName);
    if (!statusObj) {
      stopLoading();
      return;
    }
    const task = filteredTasks.find((t) => t.Id === taskId);
    if (!task) {
      stopLoading();
      return;
    }
    const body = {
      Id: taskId,
      ProjectId: Number(task.ProjectId),
      TaskTitle: task.TaskTitle,
      TaskDescription: task.TaskDescription || "",
      AssignedToId: Number(task.AssignedToId),
      ReporterId: Number(task.ReporterId),
      TaskTypeId: Number(task.TaskTypeId),
      PriorityId: Number(task.PriorityId),
      SeverityId: Number(task.SeverityId),
      StatusId: Number(statusObj.Id),
      ModuleId: Number(task.ModuleId),
      SubModuleId: Number(task.SubModuleId),
      SegmentId: Number(task.SegmentId),
      DueDate: task.DueDate?.split(" ")[0] || "",
      EstimatedHours: Number(task.EstimatedHours || 0),
      Comment: "",
      SprintId: Number(task?.SprintId),
      ActualHours: Number(task?.ActualHours || 0),
      ParentTaskId: Number(task?.ParentTaskId || 0),
    };

    try {
      await addProjectTask(body);
      await getProjectTask(1, rowsRef.current);
      GetMasterSystemAlertList("Status_Update", 0);
      setSelectedTask((prev) => ({
        ...prev,
        StatusName: statusName,
        StatusId: statusObj.Id,
      }));
    } catch (err) {
      toster.current.error(err.data.Data?.Message || "somthing went wrong");
    } finally {
      stopLoading();
    }
  };

  const onClosePopup = (e) => {
    setAddModalOpen(false);
    setEditTaskDetails({});
    setProjectId(0);
    if (e === "success") {
      getProjectTask(1, rowsRef.current);
    }
    setParentId(0);
    setTaskCopy(false);
    setFirst(0);
  };

  const handleDrop = async (event, task) => {
    event.preventDefault();
    const statusObj = taskStatusType.find((s) => s.Name === task);
    if (!statusObj) return;

    setFilteredTasks((prev) =>
      prev.map((f) =>
        f.Id === selectedTaskDrag.Id
          ? { ...f, StatusName: task, StatusId: statusObj.Id }
          : f
      )
    );

    startLoading();
    const body = {
      Id: selectedTaskDrag.Id,
      ProjectId: Number(selectedTaskDrag.ProjectId),
      TaskTitle: selectedTaskDrag.TaskTitle,
      TaskDescription: selectedTaskDrag.TaskDescription || "",
      AssignedToId: Number(selectedTaskDrag.AssignedToId),
      ReporterId: Number(selectedTaskDrag.ReporterId),
      TaskTypeId: Number(selectedTaskDrag.TaskTypeId),
      PriorityId: Number(selectedTaskDrag.PriorityId),
      SeverityId: Number(selectedTaskDrag.SeverityId),
      StatusId: Number(statusObj?.Id),
      ModuleId: Number(selectedTaskDrag.ModuleId),
      SubModuleId: Number(selectedTaskDrag.SubModuleId),
      SegmentId: Number(selectedTaskDrag.SegmentId),
      DueDate: selectedTaskDrag.DueDate?.split(" ")[0] || "",
      EstimatedHours: Number(selectedTaskDrag.EstimatedHours || 0),
      Comment: "",
      SprintId: 0,
      ActualHours: 0,
      ParentTaskId: selectedTaskDrag?.ParentTaskId || 0,
    };
    try {
      const response = await addProjectTask(body);
      if (response?.StatusCode === 2000) {
        toster.current.success("Task status updated successfully");
        await getProjectTask(1, rowsRef.current);
      } else {
        toster.current.error("Something went wrong. Please try again.");
      }
    } catch (err) {
      toster.current.error("Something went wrong. Please try again.");
      console.log(err);
    } finally {
      stopLoading();
    }
  };

  const handleAssigneeChange = async (newEmpId) => {
    const emp = employeDetails.find((em) => em.Id === newEmpId);
    startLoading();
    const body = {
      Id: selectedTask.Id,
      ProjectId: Number(selectedTask.ProjectId),
      TaskTitle: selectedTask.TaskTitle,
      TaskDescription: selectedTask.TaskDescription || "",
      AssignedToId: newEmpId,
      ReporterId: Number(selectedTask.ReporterId),
      TaskTypeId: Number(selectedTask.TaskTypeId),
      PriorityId: Number(selectedTask.PriorityId),
      SeverityId: Number(selectedTask.SeverityId),
      StatusId: Number(selectedTask.StatusId),
      ModuleId: Number(selectedTask.ModuleId),
      SubModuleId: Number(selectedTask.SubModuleId),
      SegmentId: Number(selectedTask.SegmentId),
      DueDate: selectedTask.DueDate?.split(" ")[0] || "",
      EstimatedHours: Number(selectedTask.EstimatedHours || 0),
      Comment: "",
      SprintId: Number(selectedTask?.SprintId || 0),
      ActualHours: Number(selectedTask?.ActualHours || 0),
      ParentTaskId: Number(selectedTask?.ParentTaskId || 0),
    };
    try {
      await addProjectTask(body);
      await getProjectTask(1, rowsRef.current);
      setSelectedTask((prev) => ({
        ...prev,
        AssignedToId: newEmpId,
        AssignToName: emp?.FullName || prev.AssignToName,
      }));
    } catch (err) {
      console.log(err);
    } finally {
      stopLoading();
    }
  };

  // ─── RENDER ──────────────────────────────────────────────────────────────────
  return (
    <div className="">
      <div className="task-top-pane">
        <i className="fa fa-thumb-tack i-ico" aria-hidden="true"></i>
        <div className="task-top-pane-title">
          <h4>Welcome to OrgGenie</h4>
          <p>Manage your tasks, projects, and workspaces in one place.</p>
        </div>
      </div>
      <div className="tm-main-area">
        <div className="page-head">
          <div>
            <h2>{header}</h2>
          </div>
          <div className="head-actions">
            <div className="flex ic gap8">
              <Link
                to="/Project/Dashboard"
                className="btn-og btn-og-secondary btn-og-sm"
                style={{ display: "flex", justifyContent: "flex-start" }}
                title="Back"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-arrow-left"
                  viewBox="0 0 16 16"
                >
                  <path
                    fillRule="evenodd"
                    d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8"
                  />
                </svg>
              </Link>

              <div className="vtog">
                <div className="head-actions">
                  <Link
                    to="/Project/Help"
                    className="btn btn-info text-white "
                    title="Task help"
                  >
                    <i className="fa fa-info" aria-hidden="true"></i>
                  </Link>
                </div>
                <button
                  className={`vbtn ${view === "list" ? "active" : ""}`}
                  onClick={() => setView("list")}
                >
                  <i className="fa-solid fa-list"></i> List
                </button>
                <button
                  className={`vbtn ${view === "board" ? "active" : ""}`}
                  onClick={() => setView("board")}
                >
                  <i className="fa-solid fa-table-columns"></i> Board
                </button>
              </div>

              <button
                className="btn btn-brand btn-sm"
                onClick={() => setAddModalOpen(true)}
              >
                <i className="fa-solid fa-plus"></i> New Task
              </button>
            </div>
          </div>
        </div>

        <div className="page">
          {/* SUMMARY COLLAPSIBLE SECTION */}
          <div className="collapsible-section" id="summarySection">
            <div
              className="section-toggle summery-box-label"
              onClick={() => toggleSection("summary")}
            >
              <div className="section-toggle-icon icon-summary">
                <svg
                  viewBox="0 0 28 28"
                  width="16"
                  height="16"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                >
                  <rect width="28" height="28" rx="8" fill="none" />
                  <rect x="7" y="15" width="4" height="7" rx="1" fill="#1a56db" />
                  <rect x="12" y="11" width="4" height="11" rx="1" fill="#1a56db" />
                  <rect x="17" y="7" width="4" height="15" rx="1" fill="#1a56db" />
                </svg>
              </div>
              <span className="section-label">Summary</span>
              {!summaryOpen &&
                STATUS_UI.map((item) => (
                  <div key={item.key} className={`stat-card ${item.className}`}>
                    <div className="sc-label ">{item.key}</div>
                    <div className="sc-value">{statusMap[item.key] || 0}</div>
                    <i className={`fa ${item.icon} sc-icon`}></i>
                  </div>
                ))}
              <span className="section-hint" id="summaryHint">
                Task Overview
              </span>
              <div
                className={`section-toggle-arrow ${summaryOpen ? "open" : ""}`}
                id="summaryChevron"
                style={{ color: "#1a56db" }}
              >
                {renderToggleArrow(summaryOpen, "#1a56db")}
              </div>
            </div>

            <div
              className={`section-body ${summaryOpen ? "open" : ""}`}
              id="summaryBody"
            >
              <div
                className="section-body-inner"
                onClick={(e) => e.stopPropagation()}
              >
                <div id="sumStrip">
                  <div
                    className="stat-grid mb-0"
                    style={{ gridTemplateColumns: "repeat(5,1fr)" }}
                  >
                    {STATUS_UI.map((item) => (
                      <div
                        key={item.key}
                        className={`stat-card ${item.className}`}
                      >
                        <div className="sc-label">{item.key}</div>
                        <div className="sc-value">
                          {statusMap[item.key] || 0}
                        </div>
                        <i className={`fa ${item.icon} sc-icon`}></i>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* FILTER COLLAPSIBLE SECTION */}
          <div
            className="collapsible-section"
            id="filterSection"
            onClick={() => toggleSection("filter")}
          >
            <div className="section-toggle">
              <div
                className="section-toggle-icon icon-filter"
                onClick={() => toggleSection("filter")}
              >
                <svg
                  viewBox="0 0 28 28"
                  width="28"
                  height="28"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                >
                  <rect width="28" height="28" rx="8" fill="#f0fdf4" />
                  <path
                    d="M7 9.5h14M9.5 14h9M12 18.5h4"
                    stroke="#15803d"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                  />
                </svg>
              </div>
              <span
                className="section-label"
                onClick={() => toggleSection("filter")}
              >
                Filters
              </span>

              <div
                className="sort-bydiv"
                onClick={(e) => e.stopPropagation()}
              >
                <label
                  style={{
                    fontSize: "11px",
                    color: "var(--muted)",
                    whiteSpace: "nowrap",
                    marginBottom: "0",
                  }}
                >
                  Sort By:
                </label>
                <select
                  className="fs"
                  style={{ width: "auto" }}
                  value={sortBy}
                  onChange={(e) => {
                    setSortBy(e.target.value);
                    setSortOrder("ASC");
                  }}
                >
                  {SORT_OPTIONS.map((opt) => (
                    <option key={opt.value} value={opt.value}>
                      {opt.label}
                    </option>
                  ))}
                </select>

                <button
                  type="button"
                  className="btn btn-ghost btn-icon btn-sm"
                  title={
                    sortOrder === "ASC"
                      ? "Ascending — click for Descending"
                      : "Descending — click for Ascending"
                  }
                  onClick={toggleSortOrder}
                  disabled={!sortBy}
                  style={{
                    opacity: sortBy ? 1 : 0.35,
                    cursor: sortBy ? "pointer" : "not-allowed",
                    fontSize: "13px",
                    width: "30px",
                    height: "30px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    border: "1px solid var(--border)",
                    borderRadius: "var(--radius)",
                    background: sortBy ? "var(--card)" : "transparent",
                    transition: "all 0.15s",
                  }}
                >
                  {sortOrder === "ASC" ? (
                    <i className="fa-solid fa-arrow-up-a-z"></i>
                  ) : (
                    <i className="fa-solid fa-arrow-down-z-a"></i>
                  )}
                </button>
              </div>
            </div>

            <div
              className={`section-body ${filterOpen ? "open" : ""}`}
              id="filterBody"
            >
              <div
                className="section-body-inner"
                onClick={(e) => e.stopPropagation()}
              >
                <div className="toolbar my-toolbar">
                  <div className="toolbar-sepdiv">
                    <div
                      className="sw"
                      style={{ flex: "2 1 220px", minWidth: 180 }}
                    >
                      <i className="fa-solid fa-magnifying-glass"></i>
                      <input
                        className="si"
                        placeholder="Search tasks, ID…"
                        value={inputText}
                        onChange={(e) => {
                          const value = e.target.value;
                          setInputText(value);
                          if (debounceTimerRef.current)
                            clearTimeout(debounceTimerRef.current);
                          debounceTimerRef.current = setTimeout(() => {
                            setSearchText(value);
                          }, 1000);
                        }}
                        style={{ width: "100%" }}
                      />
                    </div>

                    <div className="tsep"></div>

                    <MultiSelect
                     value={selectedStatus.filter(v => v !== 0)} 
                      onChange={(e) => {
                        let value;
                        if (!e.value || e.value.length === 0) {
                          value = [0];
                        } else {
                          // Remove 0 if user selected something
                          const filtered = e.value.filter(v => v !== 0);
                          value = filtered.length > 0 ? filtered : [0];
                        }
                        selectedStatusRef.current = value;
                        setSelectedStatus(value);
                      }}
                      options={taskStatusType}
                      optionLabel="Name"
                      optionValue="Id"
                      placeholder="All Status"
                      filter
                    />

                    <MultiSelect
                      value={selectedAssingToName}
                      onChange={(e) => setSelectedAssingToName(e.value)}
                      options={sortedEmployeeDetails}
                      optionLabel="FullName"
                      optionValue="Id"
                      placeholder="Assigned To"
                      filter
                      onShow={() => setPanelVisible(true)}
                      onHide={() => setPanelVisible(false)}
                      itemTemplate={employeeOptionTemplate}
                      style={{ flex: "1 1 140px", minWidth: 130 }}
                    />

                    <MultiSelect
                      value={selectedType}
                      onChange={(e) => setSelectedType(e.value)}
                      options={taskType}
                      optionLabel="Name"
                      optionValue="Id"
                      placeholder="All Types"
                      filter
                    />

                    <MultiSelect
                      value={selectedPriority}
                      onChange={(e) => setSelectedPriority(e.value)}
                      options={taskPriorityType}
                      optionLabel="Name"
                      optionValue="Id"
                      placeholder="All Priority"
                      filter
                    />

                    <MultiSelect
                      value={selectedSeverity}
                      onChange={(e) => setSelectedSeverity(e.value)}
                      options={taskSeverityType}
                      optionLabel="Name"
                      optionValue="Id"
                      placeholder="All Severity"
                      filter
                    />

                    <Dropdown
                      value={selectedProject ?? null}
                      options={allProject}
                      optionLabel="Name"
                      optionValue="Id"
                      placeholder="All Projects"
                      filter
                      showClear
                      style={{ flex: "1 1 150px", minWidth: 140 }}
                      onChange={(e) => {
                        const val = e.value ?? null;
                        setSelectedProject(val);
                        selectedProjectRef.current = val;
                        setSelectedModule([]);
                        setSelectedSubModule([]);
                        setSelectedSegment([]);
                        setTaskModuleType([]);
                        setTaskSubModuleType([]);
                        setTaskSegmentType([]);
                        if (val) {
                          getMasterTaskModulesCategory(val);
                          getMasterTaskSegementCategory(val);
                        }
                      }}
                    />

                    <MultiSelect
                      value={selectedModule}
                      onChange={(e) => {
                        const val = e.value;
                        setSelectedModule(val);
                        setSelectedSubModule([]);
                        setTaskSubModuleType([]);
                        if (val?.length === 1)
                          getMasterTaskSubModuleCategory(
                            selectedProject,
                            val[0]
                          );
                      }}
                      options={taskModuleType}
                      optionLabel="Name"
                      optionValue="Id"
                      placeholder="Select Module"
                      filter
                      disabled={!selectedProject}
                    />

                    <MultiSelect
                      value={selectedSubModule}
                      onChange={(e) => setSelectedSubModule(e.value)}
                      options={taskSubModuleType}
                      optionLabel="Name"
                      optionValue="Id"
                      placeholder="Select Sub-Module"
                      filter
                      disabled={!selectedModule.length}
                    />

                    <MultiSelect
                      value={selectedSegment}
                      onChange={(e) => setSelectedSegment(e.value)}
                      options={taskSegmentType}
                      optionLabel="Name"
                      optionValue="Id"
                      placeholder="Select Segment"
                      filter
                      disabled={!selectedProject}
                    />

                    <label
                      style={{
                        fontSize: "11px",
                        color: "var(--muted)",
                        whiteSpace: "nowrap",
                        marginBottom: "0",
                      }}
                    >
                      From:
                    </label>
                    <input
                      type="date"
                      className="fc"
                      style={{ width: "auto" }}
                      value={startDate}
                      onChange={(e) => setStartDate(e.target.value)}
                      onClick={(e) =>
                        e.target.showPicker && e.target.showPicker()
                      }
                    />
                    <span
                      style={{
                        fontSize: "11px",
                        color: "var(--muted)",
                        marginBottom: "0",
                      }}
                    >
                      To
                    </span>
                    <input
                      type="date"
                      className="fc"
                      style={{ width: "auto" }}
                      value={endDate}
                      onChange={(e) => setEndDate(e.target.value)}
                      onClick={(e) =>
                        e.target.showPicker && e.target.showPicker()
                      }
                    />

                    <div className="tsep"></div>
                    <button
                      className="btn btn-ghost btn-sm"
                      onClick={clearFilters}
                      disabled={!hasActiveFilters}
                      title="Clear all filters"
                      style={{
                        opacity: hasActiveFilters ? 1 : 0.4,
                        cursor: hasActiveFilters ? "pointer" : "not-allowed",
                      }}
                    >
                      <i className="fa-solid fa-xmark"></i> Clear
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="flex" style={{ flex: "1" }}>
            <div
              style={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                overflowY: "hidden",
              }}
            >
              {/* LIST VIEW */}
              <div
                className="height-body-equal"
                id="listView"
                style={{ display: view === "list" ? "block" : "none" }}
              >
                <table className="dtbl">
                  <thead>
                    <tr>
                      <th>Title</th>
                      <th>Task ID</th>
                      <th title="Type | Priority | Severity">TY | PR | SV</th>
                      <th>Status</th>
                      <th style={{ minWidth: "160px" }}>Assigned</th>
                      <th>Due By | Est(hr)</th>
                      <th className="task-actions-header">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredTasks?.length === 0 ? (
                      <tr>
                        <td
                          colSpan="13"
                          style={{ textAlign: "center", padding: "20px" }}
                        >
                          No Data Found
                        </td>
                      </tr>
                    ) : (
                      filteredTasks?.map((task) => (
                        <tr
                          key={task?.Id}
                          onClick={() => {
                            openPanel(task.Id);
                            fetchPanelEmployees(task?.ProjectId || 0);
                          }}
                          className={`${selectedTask?.Id === task?.Id ? "row-selected" : ""}`}
                          style={{
                            background:
                              selectedTask?.Id === task?.Id
                                ? "var(--brand-soft, rgba(236,65,25,0.08))"
                                : "",
                            borderLeft:
                              selectedTask?.Id === task?.Id
                                ? "3px solid var(--brand)"
                                : "3px solid transparent",
                            transition: "background 0.15s, border-left 0.15s",
                          }}
                        >
                          <td className="title-cell">
                            <p
                              className="mb-0 task-headingp"
                              style={{ fontWeight: 600 }}
                            >
                              <b>
                                {getValue(
                                  (() => {
                                    const max =
                                      selectedTask?.Id === task?.Id ? 45 : 65;
                                    return task.TaskTitle?.length > max
                                      ? task.TaskTitle.slice(0, max) + "..."
                                      : task.TaskTitle;
                                  })()
                                )}
                                <span
                                  title="Copy title with link"
                                  style={{ marginLeft: "6px", cursor: "pointer", flexShrink: 0, display: "inline-flex", verticalAlign: "middle" }}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    const url = `https://app.orggenie.com/Project/Task/Detail/${task.GUID}`;
                                    const plainText = `${task.TaskTitle}\n${url}`;
                                    const htmlText = `<a href="${url}">${task.TaskTitle}</a>`;
                                    if (navigator.clipboard && window.ClipboardItem) {
                                      navigator.clipboard.write([new ClipboardItem({
                                        "text/plain": new Blob([plainText], { type: "text/plain" }),
                                        "text/html": new Blob([htmlText], { type: "text/html" }),
                                      })]);
                                    } else {
                                      navigator.clipboard.writeText(plainText);
                                    }
                                    setCopiedId(`tasknum-${task.Id}`);
                                    setTimeout(() => setCopiedId(null), 2000);
                                  }}
                                >
                                  {copiedId === `tasknum-${task.Id}` ? (
                                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#22c55e" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" style={{ width: "13px", height: "13px" }}>
                                      <polyline points="20 6 9 17 4 12" />
                                    </svg>
                                  ) : (
                                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#888" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ width: "13px", height: "13px" }}>
                                      <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
                                      <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
                                    </svg>

                                  )}
                                </span>

                              </b>

                              {task.ParentTaskId !== 0 && (
                                <svg
                                  // title={task?.ParentTaskNumber}
                                  xmlns="http://w3.org"
                                  viewBox="0 0 24 24"
                                  width="16"
                                  height="16"
                                  style={{ marginLeft: "6px", flexShrink: 0 }}
                                > <title>{task?.ParentTaskNumber}</title>
                                  <rect
                                    x="3"
                                    y="3"
                                    width="6"
                                    height="6"
                                    rx="1.5"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linejoin="round"
                                  />
                                  <line
                                    x1="12"
                                    y1="5"
                                    x2="21"
                                    y2="5"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                  />
                                  <line
                                    x1="12"
                                    y1="8"
                                    x2="18"
                                    y2="8"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                  />
                                  <path
                                    d="M6 10v6h4"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                  <rect
                                    x="12"
                                    y="13"
                                    width="6"
                                    height="6"
                                    rx="1"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linejoin="round"
                                  />
                                  <line
                                    x1="20"
                                    y1="15"
                                    x2="21"
                                    y2="15"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                  />
                                  <line
                                    x1="20"
                                    y1="18"
                                    x2="21"
                                    y2="18"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                  />
                                </svg>
                              )}
                            </p>
                            <div className="module-status">
                              <span>
                                <span
                                  title={task.IsPublic ? "Public" : "Private"}
                                  style={{
                                    fontSize: "11px",
                                    marginRight: "4px",
                                    marginLeft: "0",
                                    color: task.IsPublic
                                      ? "var(--red, #e53e3e)"
                                      : "var(--muted, #888)",
                                    flexShrink: 0,
                                  }}
                                >
                                  <i
                                    className={`fa-solid ${task.IsPublic ? "fa-lock-open" : "fa-lock"}`}
                                  ></i>
                                </span>
                                {getValue(task?.ProjectName)}
                              </span>
                              <span>| </span>
                              <span>{getValue(task.ModuleName)} - </span>
                              <span>{getValue(task.SubModuleName)}</span>
                              <span>| </span>
                              <span>{getValue(task.SegmentName)}</span>
                              <span>| </span>
                              <span
                                className="w-s"
                                style={{
                                  display: "flex",
                                  alignItems: "start",
                                  gap: "6px",
                                  whiteSpace: "nowrap",
                                }}
                                title="Created By"
                                onClick={() => {
                                  if (task?.CreatedByUserGUID) {
                                    window.open(
                                      `/Profile/${task?.CreatedByUserGUID}`,
                                      "_blank"
                                    );
                                  }
                                }}
                              >
                                <img
                                  src={
                                    task.CreatedByProfileImage ||
                                    "images/placeholder_profile.png"
                                  }
                                  onError={(e) =>
                                  (e.target.src =
                                    "/images/placeholder_profile.png")
                                  }
                                  style={{
                                    width: "15px",
                                    height: "15px",
                                    borderRadius: "50%",
                                  }}
                                />
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                  }}
                                >
                                  {getValue(task.CreatedByFullName)}
                                </div>
                              </span>
                            </div>
                          </td>
                          <td className="w-s">
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "4px",
                                flexWrap: "wrap",
                              }}
                            >
                              <b className="task-number-td">
                                {getValue(task.TaskNumber)}
                              </b>
                              <span
                                title="Copy Task ID"
                                style={{ cursor: "pointer", flexShrink: 0, lineHeight: 1 }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  navigator.clipboard.writeText(task.TaskNumber ?? "");
                                  setCopiedId(`title-${task.Id}`);
                                  setTimeout(() => setCopiedId(null), 1500);
                                }}
                              >
                                {copiedId === `title-${task.Id}` ? (
                                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#22c55e" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                                    <polyline points="20 6 9 17 4 12" />
                                  </svg>
                                ) : (
                                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#888" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
                                    <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
                                  </svg>
                                )}
                              </span>
                              <br />
                              {task.SprintName && (
                                <span style={{ display: "block", width: "100%" }}>{task.SprintName}</span>
                              )}
                            </div>
                          </td>
                          <td>
                            {getValue(task.TaskTypeName)}
                            <br />
                            {getValue(task.PriorityName)} |{" "}
                            {getValue(task.SeverityName)}
                          </td>
                          <td>
                            <div
                              className={`badge ${sBadge(task?.StatusName)}`}
                            >
                              {getValue(task.StatusName)}
                            </div>
                          </td>
                          <td>
                            <div
                              className="w-s"
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "6px",
                                width: "100px",
                                whiteSpace: "nowrap",
                              }}
                              title="Assigned By"
                              onClick={() => {
                                if (task?.AssignToUserGUID) {
                                  window.open(
                                    `/Profile/${task?.AssignToUserGUID}`,
                                    "_blank"
                                  );
                                }
                              }}
                            >
                              {task.AssignToProfileImage && (
                                <img
                                  src={
                                    task.AssignToProfileImage ||
                                    "images/placeholder_profile.png"
                                  }
                                  onError={(e) =>
                                  (e.target.src =
                                    "/images/placeholder_profile.png")
                                  }
                                  style={{
                                    width: "20px",
                                    height: "20px",
                                    borderRadius: "50%",
                                  }}
                                />
                              )}
                              {getValue(task.AssignToName)}
                            </div>
                          </td>
                          <td>
                            {task.DueDate
                              ? new Date(task.DueDate).toLocaleDateString()
                              : "N/A"}
                            <br />
                            {task.EstimatedHours
                              ? `${task.EstimatedHours}h`
                              : "N/A"}
                          </td>
                          <td
                            className="task-actions-cell"
                            onClick={(e) => e.stopPropagation()}
                          >
                            <div className="flex gap4 task-actions">
                              <button
                                title="Clone"
                                type="button"
                                onClick={() => {
                                  setAddModalOpen(true);
                                  setEditTaskDetails(task);
                                  setParentId(0);
                                  setProjectId(task?.ProjectId);
                                  setTaskCopy(true);
                                }}
                                className="btn btn-ghost btn-icon"
                              >
                                <i className="fa-solid fa-copy"></i>
                              </button>
                              <button
                                title="Edit"
                                type="button"
                                onClick={() => {
                                  setAddModalOpen(true);
                                  setEditTaskDetails(task);
                                  setParentId(0);
                                  setProjectId(task?.ProjectId);
                                  setTaskCopy(false);
                                }}
                                className="btn btn-ghost btn-icon"
                              >
                                <i className="fa-solid fa-pen"></i>
                              </button>
                              <button
                                title="Delete"
                                className="btn btn-ghost btn-icon"
                                style={{ color: "var(--red)" }}
                                onClick={() => {
                                  setDeleteModal(true);
                                  setDeletedTaskId(task?.Id);
                                }}
                              >
                                <i className="fa-solid fa-trash"></i>
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
                <Paginator
                  first={first}
                  rows={rows}
                  totalRecords={totalRecords}
                  rowsPerPageOptions={[50, 100, 200, 500]}
                  onPageChange={onPageChange}
                />
              </div>

              {/* BOARD VIEW */}
              <div
                id="boardView"
                style={{
                  display: view === "board" ? "flex" : "none",
                  flex: 1,
                  overflow: "hidden",
                  padding: "0 18px 14px",
                }}
              >
                <div className="kw">
                  <div style={{ display: "flex", gap: "12px", width: "100%" }}>
                    {COLUMNS?.map((col) => {
                      const normalize = (value) =>
                        value?.replace(/\s/g, "").toLowerCase();
                      const columnTasks = filteredTasks.filter(
                        (t) => normalize(t?.StatusName) == normalize(col)
                      );

                      return (
                        <div key={col} className="kcol">
                          <div className="kch">
                            <div
                              style={{
                                width: "9px",
                                height: "9px",
                                borderRadius: "50%",
                                background: COLUMN_COLORS[col],
                              }}
                            />
                            <span className="kch-title">{col}</span>
                            <span
                              className="kch-cnt"
                              style={{
                                background: COLUMN_COLORS[col] + "22",
                                color: COLUMN_COLORS[col],
                              }}
                            >
                              {(() => {
                                let colTasks = filteredTasks.filter((task) => {
                                  if (
                                    col === "Resolved" ||
                                    col === "Done"
                                  ) {
                                    return (
                                      task.StatusName === "Resolved" ||
                                      task.StatusName === "Done" ||
                                      task.StatusId === 104
                                    );
                                  }
                                  return task.StatusName === col;
                                });
                                return colTasks?.length;
                              })()}
                            </span>
                            <button
                              title="Add Task"
                              className="btn btn-ghost btn-icon btn-sm mla"
                              onClick={() => {
                                setEditTaskDetails({});
                                setAddModalOpen(true);
                                setParentId(0);
                                setProjectId(0);
                                setTaskCopy(false);
                              }}
                            >
                              <i className="fa-solid fa-plus"></i>
                            </button>
                          </div>

                          <div
                            className="kcb"
                            onDragOver={(e) => e.preventDefault()}
                            onDrop={(e) => handleDrop(e, col)}
                            style={{ pointerEvents: "auto" }}
                          >
                            {columnTasks?.length === 0 ? (
                              <div
                                style={{ padding: "10px", color: "#999" }}
                              >
                                No Tasks
                              </div>
                            ) : (
                              columnTasks?.map((t) => {
                                const isOverdue =
                                  t?.DueDate &&
                                  new Date(t.DueDate) < new Date() &&
                                  col !== "Closed" &&
                                  col !== "Done";

                                return (
                                  <div
                                    key={t.Id}
                                    className="kcard"
                                    draggable
                                    onDragStart={(e) => {
                                      e.dataTransfer.setData("taskId", t.Id);
                                      setSelectedTaskDrag(t);
                                    }}
                                    onDragOver={(e) => e.preventDefault()}
                                    onClick={(e) => openPanel(t.Id)}
                                    style={{ position: "relative" }}
                                  >
                                    <div className="kcard-id">
                                      {t.TaskNumber || "-"}
                                    </div>
                                    <div className="kcard-title">
                                      {t.TaskTitle || "No Title"}
                                    </div>
                                    <div className="kcard-meta">
                                      <span className="badge">
                                        {t.PriorityName || "n/a"}
                                      </span>
                                      <span className="badge">
                                        {t.SegmentName || "-"}
                                      </span>
                                      {isOverdue && (
                                        <span style={{ color: "red" }}>⚠</span>
                                      )}
                                    </div>
                                    <div className="kcard-foot">
                                      <img
                                        src={
                                          t.AssignToProfileImage ||
                                          "/images/placeholder_profile.png"
                                        }
                                        alt=""
                                        style={{
                                          width: "20px",
                                          height: "20px",
                                          borderRadius: "50%",
                                        }}
                                      />
                                      <span style={{ fontSize: "11px" }}>
                                        {(
                                          t.AssignToName || "User"
                                        ).split(" ")[0]}
                                      </span>
                                      {t.DueDate && (
                                        <span
                                          style={{
                                            marginLeft: "auto",
                                            fontSize: "10px",
                                            color: isOverdue ? "red" : "#888",
                                          }}
                                        >
                                          {new Date(
                                            t.DueDate
                                          ).toLocaleDateString()}
                                        </span>
                                      )}
                                    </div>
                                  </div>
                                );
                              })
                            )}
                          </div>

                          <div
                            className="kadd"
                            onClick={() => {
                              setEditTaskDetails({});
                              setAddModalOpen(true);
                              setParentId(0);
                              setProjectId(0);
                              setTaskCopy(false);
                            }}
                          >
                            <i className="fa-solid fa-plus"></i> Add task
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>

              {/* BULK BAR */}
              <div
                id="bulkBar"
                style={{
                  display: showBulkBar ? "flex" : "none",
                  padding: "7px 18px",
                  background: "var(--brand-soft)",
                  borderTop: "1px solid rgba(236,65,25,.2)",
                  alignItems: "center",
                  gap: "8px",
                  flexShrink: 0,
                }}
              >
                <span
                  id="selCount"
                  style={{
                    fontSize: "12.5px",
                    fontWeight: 700,
                    color: "var(--brand)",
                  }}
                ></span>
                <div className="tsep"></div>
                <select
                  className="fs"
                  style={{ width: "130px" }}
                  id="bulkStatus"
                >
                  <option value="">Change Status</option>
                  <option>Open</option>
                  <option>In Progress</option>
                  <option>Review</option>
                  <option>Resolved</option>
                  <option>Closed</option>
                </select>
                <button
                  className="btn btn-outline btn-sm"
                  onClick={() => { }}
                >
                  Apply
                </button>
                <button
                  className="btn btn-ghost btn-sm"
                  onClick={() => setShowBulkBar(false)}
                >
                  Cancel
                </button>
              </div>
            </div>

            {/* SIDE PANEL */}
            <div
              className={`sp${selectedTask ? " open" : ""}`}
              id="sidePanel"
            >
              {selectedTask ? (
                <>
                  <div className="sp-hd">
                    <h5>{selectedTask.TaskNumber}</h5>
                    <button
                      className="btn btn-ghost btn-icon"
                      onClick={() => {
                        setAddModalOpen(true);
                        setEditTaskDetails(selectedTask);
                        setParentId(0);
                        setProjectId(selectedTask?.ProjectId);
                        setTaskCopy(false);
                      }}
                      title="Edit"
                    >
                      <i className="fa-solid fa-pen"></i>
                    </button>
                    <button
                      type="button"
                      onClick={() => taskDetail(selectedTask?.GUID)}
                      className="btn btn-ghost btn-icon"
                      title="Full View"
                    >
                      <i className="fa-solid fa-arrow-up-right-from-square"></i>
                    </button>
                    <button
                      type="button"
                      onClick={closePanel}
                      className="btn btn-ghost btn-icon"
                      title="Close"
                    >
                      <i className="fa-solid fa-xmark"></i>
                    </button>
                  </div>

                  <div className="sp-bd">
                    <div
                      className="flex project-badge-area"
                      style={{ gap: 5 }}
                    >
                      <span className="badge bg-critical">
                        {selectedTask.PriorityName || "N/A"}
                      </span>
                      <span className="badge bg-blocker">
                        {selectedTask.SeverityName || "N/A"}
                      </span>
                      <span className="badge bg-bug">
                        {selectedTask.TaskTypeName || "N/A"}
                      </span>
                      <span className="badge bg-bug">
                        {selectedTask.SprintName || "N/A"}
                      </span>
                    </div>

                    <div className="project-task-title">
                      {selectedTask.TaskTitle || "No Title"}
                    </div>

                    <div className="ql-editor project-task-description">
                      <div
                        dangerouslySetInnerHTML={{
                          __html:
                            selectedTask.TaskDescription ||
                            "<p>No description</p>",
                        }}
                      />
                    </div>

                    <div className="task-project-bx">
                      <div className="task-project-inner">
                        <div className="task-project-heading">
                          <strong>Project:</strong>
                        </div>
                        <div className="task-project-value">
                          {selectedTask.ProjectName || "N/A"}
                        </div>
                      </div>
                      <div className="task-project-inner">
                        <div className="task-project-heading">
                          <strong>Segment:</strong>
                        </div>
                        <div className="task-project-value">
                          {selectedTask.SegmentName || "N/A"}
                        </div>
                      </div>
                      <div className="task-project-inner">
                        <div className="task-project-heading">
                          <strong>Status:</strong>
                        </div>
                        <div className="task-project-value">
                          <select
                            className="sp-inline-select"
                            value={selectedTask.StatusName || ""}
                            onChange={(e) =>
                              handleStatusChange(
                                selectedTask.Id,
                                e.target.value
                              )
                            }
                          >
                            {["Open", "In Progress", "Review", "Done", "Closed"]
                              .filter(
                                (status) =>
                                  status !== "Closed" ||
                                  userPermissions?.some(
                                    (p) =>
                                      p?.PermissionName === "Task.Close"
                                  )
                              )
                              .map((status) => (
                                <option key={status} value={status}>
                                  {status}
                                </option>
                              ))}
                          </select>
                        </div>
                      </div>
                      <div className="task-project-inner">
                        <div className="task-project-heading">
                          <strong>Assigned To:</strong>
                        </div>
                        <div className="task-project-value">
                          <select
                            className="sp-inline-select"
                            value={selectedTask.AssignedToId || ""}
                            onChange={(e) =>
                              handleAssigneeChange(Number(e.target.value))
                            }
                          >
                            {!panelEmployees?.some(
                              (emp) =>
                                emp.Id === selectedTask.AssignedToId
                            ) && (
                                <option
                                  value={selectedTask.AssignedToId || ""}
                                >
                                  {selectedTask.AssignToName ||
                                    "Select Employee"}
                                </option>
                              )}
                            {panelEmployees?.map((emp) => (
                              <option key={emp.Id} value={emp.Id}>
                                {emp.FullName}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                      <div className="task-project-inner">
                        <div className="task-project-heading">
                          <strong>Module:</strong>
                        </div>
                        <div className="task-project-value">
                          {selectedTask.ModuleName || "N/A"}
                        </div>
                      </div>
                      <div className="task-project-inner">
                        <div className="task-project-heading">
                          <strong>Sub Module:</strong>
                        </div>
                        <div className="task-project-value">
                          {selectedTask.SubModuleName || "N/A"}
                        </div>
                      </div>
                      <div className="task-project-inner">
                        <div className="task-project-heading">
                          <strong>Reporter:</strong>
                        </div>
                        <div className="task-project-value">
                          {selectedTask.ReporterFullName ||
                            selectedTask.RaisedByName ||
                            "N/A"}
                        </div>
                      </div>
                      <div className="task-project-inner">
                        <div className="task-project-heading">
                          <strong>Est Time:</strong>
                        </div>
                        <div className="task-project-value">
                          {selectedTask.EstimatedHours
                            ? `${selectedTask.EstimatedHours}h`
                            : "N/A"}
                        </div>
                      </div>
                      <div className="task-project-inner">
                        <div className="task-project-heading">
                          <strong>Actual Time:</strong>
                        </div>
                        <div className="task-project-value">
                          {selectedTask.ActualHours
                            ? `${selectedTask.ActualHours}h`
                            : "N/A"}
                        </div>
                      </div>
                      <div className="task-project-inner">
                        <div className="task-project-heading">
                          <strong>Due By:</strong>
                        </div>
                        <div className="task-project-value">
                          {selectedTask.DueDate
                            ? new Date(
                              selectedTask.DueDate
                            ).toLocaleDateString()
                            : "N/A"}
                        </div>
                      </div>
                    </div>
                    <div className="project-task-status">
                      <div className="staus-project-title">Change Status</div>
                      <div className="status-wrap-project">
                        {["Open", "In Progress", "Review", "Done", "Closed"]
                          .filter(
                            (status) =>
                              status !== "Closed" ||
                              userPermissions?.some(
                                (userPermission) =>
                                  userPermission?.PermissionName ===
                                  "Task.Close"
                              )
                          )
                          .map((status) => (
                            <button
                              key={status}
                              type="button"
                              className={`btn btn-sm ${selectedTask.StatusName === status
                                ? "btn-brand"
                                : "btn-outline"
                                }`}
                              onClick={() =>
                                handleStatusChange(selectedTask.Id, status)
                              }
                            >
                              {status}
                            </button>
                          ))}
                      </div>
                    </div>
                  </div>
                </>
              ) : null}
            </div>
          </div>
        </div>
      </div>

      {/* ADD/EDIT TASK MODAL */}
      {isModalOpen && (
        <AddTask
          isOpen={isModalOpen}
          onClose={(e) => onClosePopup(e)}
          editTaskDetails={editTaskDetails}
          subTaskProjectId={subTaskProjectId}
          parentId={parentId}
          taskCopy={taskCopy}
          detailPage={false}
          activityType={0}
        />
      )}

      {/* Delete Confirmation */}
      {isDeletedModal && (
        <div
          className="modal show"
          id="delete-task-confirm"
          style={{ display: "block", background: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content delete-holiday">
              <div className="modal-header">
                <img
                  src="/images/org-img/leave/popup-backimg.png"
                  className="backimg"
                />
                <div className="img">
                  <img src="/images/org-img/leave/trash.png" />
                </div>
              </div>
              <div className="modal-body text-center">
                <p>Are you sure you want to delete this task?</p>
              </div>
              <div className="modal-footer m-auto">
                <button
                  type="button"
                  className="cancelbtn-click"
                  onClick={() => {
                    setDeleteModal(false);
                    setDeletedTaskId(0);
                  }}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="deletebtn-click"
                  onClick={() => taskDelete()}
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {isAnythingLoading && (
        <Suspense>
          <ComponentLoader />
        </Suspense>
      )}
    </div>
  );
};

export default TaskManagementList;